"use client";

import { Filmomtale, Trailer } from "@filmweb/sanity-types";
import PlayButton from "@/components/images/PlayButton";
import styles from "./TrailerButton.module.css";
import classNames from "classnames";
import { useState } from "react";
import { createPortal } from "react-dom";
import TrailerOverlay from "@/components/filmweb/movie/TrailerOverlay";

//#region [Props]
type TrailerButtonProps = {
    film: Filmomtale;
    className?: string;
    label?: string;
};
//#endregion

//#region [Component]
export default function TrailerButton({ film, className, label }: TrailerButtonProps) {
    const [isShowingOverlay, showOverlay] = useState(false);

    const trailer = film.trailersOverride?.[0] ?? film.trailers?.[0];
    if (!trailer) {
        return null;
    }
    return <>
        <button className={classNames(styles.TrailerButton, className)} onClick={() => showOverlay(true)}>
            <PlayButton alt="Spill av trailer" />
            {label}
        </button>
        {isShowingOverlay && createPortal(<TrailerOverlay videoId={(trailer as Trailer).videoId} doClose={() => showOverlay(false)} />, document.body)}
    </>;
}
//#endregion
